import React, { useContext } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaBook, FaBoxOpen, FaRetweet } from "react-icons/fa";
import { Context } from "../../index";

const ChooseAddType = ({ onClose }) => {
    const navigate = useNavigate();
    const { user } = useContext(Context);

    const cardStyle = {
        borderRadius: "6px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid gray",
        transition: "transform 0.2s, box-shadow 0.2s",
        cursor: "pointer",
        height: "136px",
    };

    const addBookGrab = () => {
        user?.setActiveComponent("AddBookByGrabFromAmazon");
        if (onClose) onClose();
    };

    const addProductGrab = () => {
        user?.setActiveComponent("AddProductByGrabFromAmazon");
        if (onClose) onClose();
    };

    const transferFromAnotherAccount = () => {
        user?.setActiveComponent("TransferBookFromAnotherAccount");
        if (onClose) onClose();
    };

    return (
        <Container className="d-flex flex-column align-items-center justify-content-center mt-5">
            {/* --- мобильная адаптация --- */}
            <style>{`
                @media (max-width: 767.98px) {
                    .choose-card {
                        height: auto !important;
                        padding: 12px !important;
                    }
                    .choose-card .card-body {
                        padding: 10px 12px !important;
                    }
                    .choose-card .icon-col svg {
                        width: 60px !important;
                        height: 60px !important;
                    }
                    .choose-card .text-col p {
                        font-size: 0.85rem !important;
                        line-height: 1.1rem !important;
                        margin-bottom: 4px !important;
                    }
                    .choose-card .text-col p.fw-bold {
                        font-size: 0.95rem !important;
                    }
                }
            `}</style>

            <h4 className="fw-bold mb-4 text-center text-muted">
                What would you like to add to the Virtalibry system?
            </h4>

            <Row className="justify-content-center" style={{ rowGap: "16px" }}>
                {/* === BOOK CARD === */}
                <Col xs={12} md={5} className="mb-3">
                    <Card
                        style={cardStyle}
                        className="choose-card mt-0 mb-1 mx-2"
                        onClick={addBookGrab}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow =
                                "0px 6px 16px rgba(0, 0, 0, 0.2)";
                            e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow =
                                "0px 2px 4px rgba(0, 0, 0, 0.1)";
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                    >
                        <Card.Body style={{ padding: "18px 9px", paddingRight: "16px" }}>
                            <Row className="align-items-center">
                                {/* Левая часть — иконка */}
                                <Col
                                    xs={3}
                                    md={4}
                                    className="icon-col d-flex justify-content-center align-items-center"
                                    style={{
                                        borderRadius: "2px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <FaBook size={80} className="text-success" />
                                </Col>

                                {/* Правая часть — текст */}
                                <Col md={8} xs={9} className="text-col text-start small px-2">
                                    <p
                                        className="fw-bold mb-1 text-muted"
                                        style={{
                                            fontSize: "0.95rem",
                                            lineHeight: "1.2rem",
                                        }}
                                    >
                                        Add Your Book
                                    </p>
                                    <p
                                        className="mb-1 text-muted"
                                        style={{
                                            fontSize: "0.85rem",
                                            lineHeight: "1.1rem",
                                        }}
                                    >
                                        Grab your book data directly from Amazon or Add Manually.
                                    </p>
                                    <p
                                        className="text-muted mb-0"
                                        style={{
                                            fontSize: "0.8rem",
                                            lineHeight: "1rem",
                                        }}
                                    >
                                        We Support: <strong>Kindle</strong>,{" "}
                                        <strong>Paperback</strong>,{" "}
                                        <strong>Hardcover</strong> and{" "}
                                        <strong>Audiobook</strong> editions.
                                    </p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* === PRODUCT CARD === */}
                <Col xs={12} md={5} className="mb-3">
                    <Card
                        style={cardStyle}
                        className="choose-card mt-0 mb-3 mx-2"
                        onClick={addProductGrab}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow =
                                "0px 6px 16px rgba(0, 0, 0, 0.2)";
                            e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow =
                                "0px 2px 4px rgba(0, 0, 0, 0.1)";
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                    >
                        <Card.Body style={{ padding: "18px 9px", paddingRight: "16px" }}>
                            <Row className="align-items-center">
                                <Col
                                    xs={3}
                                    md={4}
                                    className="icon-col d-flex justify-content-center align-items-center"
                                    style={{
                                        borderRadius: "2px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <FaBoxOpen size={90} className="text-success" />
                                </Col>

                                <Col md={8} xs={9} className="text-col text-start small px-2">
                                    <p
                                        className="fw-bold mb-1 text-muted"
                                        style={{
                                            fontSize: "0.95rem",
                                            lineHeight: "1.2rem",
                                        }}
                                    >
                                        Add Your FBA Product
                                    </p>
                                    <p
                                        className="mb-1 text-muted"
                                        style={{
                                            fontSize: "0.85rem",
                                            lineHeight: "1.1rem",
                                        }}
                                    >
                                        Grab your product data from Amazon or Add Manually.
                                    </p>
                                    <p
                                        className="text-muted mb-0"
                                        style={{
                                            fontSize: "0.8rem",
                                            lineHeight: "1rem",
                                        }}
                                    >
                                        You can add up to <strong>4 ASINs</strong> per product for{" "}
                                        <strong>colors</strong>, <strong>sizes</strong> or{" "}
                                        <strong>variants</strong>.
                                    </p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* === TRANSFER CARD === */}
                <Col xs={12} md={5} className="mb-3">
                    <Card
                        style={cardStyle}
                        className="choose-card mt-0 mb-3 mx-2"
                        onClick={transferFromAnotherAccount}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow =
                                "0px 6px 16px rgba(0, 0, 0, 0.2)";
                            e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow =
                                "0px 2px 4px rgba(0, 0, 0, 0.1)";
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                    >
                        <Card.Body style={{ padding: "18px 9px", paddingRight: "16px" }}>
                            <Row className="align-items-center">
                                <Col
                                    xs={3}
                                    md={4}
                                    className="icon-col d-flex justify-content-center align-items-center"
                                    style={{
                                        borderRadius: "2px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <FaRetweet size={80} className="text-success" />
                                </Col>

                                <Col md={8} xs={9} className="text-col text-start small px-2">
                                    <p
                                        className="fw-bold mb-1 text-muted"
                                        style={{
                                            fontSize: "0.95rem",
                                            lineHeight: "1.2rem",
                                        }}
                                    >
                                        Transfer from Another Account
                                    </p>
                                    <p
                                        className="mb-1 text-muted"
                                        style={{
                                            fontSize: "0.85rem",
                                            lineHeight: "1.1rem",
                                        }}
                                    >
                                        Move a book/product you already added under another Virtalibry account.
                                    </p>
                                    <p
                                        className="text-muted mb-0"
                                        style={{
                                            fontSize: "0.8rem",
                                            lineHeight: "0.95rem",
                                        }}
                                    >
                                        Confirm with PIN codes from <strong>both account emails</strong>{" "}
                                        before ownership moves.
                                    </p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ChooseAddType;
